import React from 'react';
import { FaPoundSign, FaRobot } from 'react-icons/fa';
import './PostMetadataForm.css';

const PostMetadataForm = ({ metadata, onChange }) => {
    const handlePriceChange = (value) => {
        const parsed = Number.parseInt(value, 10);
        if (!Number.isNaN(parsed) && parsed >= 1 && parsed <= 20) {
            onChange('price', parsed);
        }
    };

    const handlePriceBlur = (value) => {
        const parsed = Number.parseInt(value, 10);
        if (Number.isNaN(parsed) || parsed < 1) {
            onChange('price', 1);
            return;
        }
        if (parsed > 20) {
            onChange('price', 20);
        }
    };

    return (
        <>
            <div className="form-group mb-4">
                <label htmlFor="post-title" className="form-label">Post Title *</label>
                <input
                    id="post-title"
                    type="text"
                    value={metadata.title}
                    onChange={(event) => onChange('title', event.target.value)}
                    placeholder="Enter post title"
                    className="form-control"
                />
            </div>

            <div className="form-check mb-3">
                <input type="hidden" name="is_paid" value="false" />
                <input
                    id="paid-content"
                    type="checkbox"
                    checked={Boolean(metadata.is_paid)}
                    onChange={(event) => {
                        const checked = event.target.checked;
                        onChange('is_paid', checked);
                        if (!checked) {
                            onChange('price', 0);
                        }
                    }}
                    className="form-check-input"
                />
                <label className="form-check-label" htmlFor="paid-content">
                    <FaPoundSign /> Paid Content
                </label>
            </div>

            {metadata.is_paid && (
                <div className="card mb-3 metadata-fields-card">
                    <div className="card-body py-3">
                        <div className="d-flex flex-wrap metadata-fields-row">
                            <div className="metadata-field credits-field d-flex align-items-center">
                                <label htmlFor="post-price" className="form-label mb-0 me-2">Credits:</label>
                                <div>
                                    <input
                                        id="post-price"
                                        type="number"
                                        value={metadata.price}
                                        onChange={(event) => handlePriceChange(event.target.value)}
                                        onBlur={(event) => handlePriceBlur(event.target.value)}
                                        min="1"
                                        max="20"
                                        style={{ width: '60px' }}
                                        className="form-control form-control-sm text-center"
                                    />
                                    <small className="form-text d-block">Enter 1-20</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="ai-score-card">
                <div className="ai-score-header">
                    <label htmlFor="ai-score" className="ai-score-label">
                        <FaRobot className="me-1" /> AI Quality Score
                    </label>
                    <span className="ai-score-badge">{metadata.ai_score} / 5</span>
                </div>
                <div className="ai-score-slider-container">
                    <input
                        id="ai-score"
                        type="range"
                        value={metadata.ai_score}
                        onChange={(event) => onChange('ai_score', Number.parseInt(event.target.value, 10) || 0)}
                        min="0"
                        max="5"
                        step="1"
                        className="ai-score-slider"
                    />
                </div>
            </div>
        </>
    );
};

export default PostMetadataForm;
